import { Stack, Typography } from '@mui/material';
import React from 'react';
import { Button } from 'src/components/shared';
import images from 'src/config/images';
import { redirectAfterLogin } from '../../../../utils/helper';

function Journey({ user }) {
  return (
    <Stack direction="column" gap={4} mt={8} alignItems="center">
      <img src={images.auth.journeySuccess} style={{ maxWidth: '220px' }} />
      <Typography color="textSecondary">
        You’re now ready to kick start your journey with SuperReach
      </Typography>
      <Button
        color="secondary"
        variant="contained"
        sx={{ borderRadius: '40px', fontWeight: '600' }}
        onClick={() => {
          if (
            (user?.lmsmonthly || user?.lmsannual) &&
            (user?.outreachAnnual || user?.outreachMonthly)
          ) {
            location.replace(
              redirectAfterLogin(
                user?.outreachAnnual || user?.outreachMonthly,
                user?.lmsmonthly || user?.lmsannual,
              ),
            );
            // location.replace('/onboarding/?welcome=true&newUser=true');
          } else {
            location.replace('/onboarding');
            // location.replace('/outreachvideolibrary');
          }
        }}
      >
        Get started
      </Button>
    </Stack>
  );
}

export default Journey;
